import React from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../../utils/components/Button/Button'
import { Table } from '../../../components/Table/Table'

const ListAdmin = ({listAdmin}) => {
const history = useHistory()
  return (
    <div>
         <div className='column mb-5'>
                <Button
                    onClick={() => {
                        history.push("/Admin/CreateAdmin")
                    }}
                    text='Crear Administrador'
                />
            </div>
        <Table>
            <thead>
                <tr>
                    <th>Nombre</th>
                    <th>Correo</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {listAdmin.map(admin=>(
                    <tr key={admin._id}>
                        <td>{admin.name}</td>
                      
                        <td>{admin.email}</td>
                        <th>
                            <Button
                             onClick={(e)=>{
                                e.preventDefault(); e.stopPropagation();
                                history.push("/Admin/Admin/"+admin._id)
                             }}
                             text='Editar'/>
                        </th>
                    </tr>
                ))}
            </tbody>
        </Table>
    </div>
  )
}

export default ListAdmin